module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content deal-freight-card",
    attrs: {
      "id": "z-deal-freight"
    }
  }, [_c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressMainFreight),
      expression: "progressMainFreight"
    }],
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:100'),
      expression: "'required|min:1|max:100'"
    }],
    attrs: {
      "label": "Наименование груза",
      "required": true,
      "name": "freight_description",
      "id": "freight_description",
      "error": _vm.errors.first('freight_description'),
      "data-vv-name": "freight_description",
      "data-vv-as": ' ',
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.description
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "description", $event)
      }
    },
    model: {
      value: (_vm.freight.description),
      callback: function($$v) {
        _vm.$set(_vm.freight, "description", $$v)
      },
      expression: "freight.description"
    }
  })], 1), _vm._m(0), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50 deal-freight-card__freight-params"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.001,
        max_value: 25000,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0.001, max_value: 25000, decimal: [3, '.']}"
    }],
    attrs: {
      "label": ('Вес (кг)' + (_vm.OversizeType.find(function (item) { return item == 'weight'; }) ? ', <span style=color: red;>Негабарит</span>' : '')),
      "required": true,
      "select-on-focus": true,
      "name": "freight_weight",
      "id": "freight_weight",
      "error": _vm.errors.first('freight_weight'),
      "data-vv-name": "freight_weight",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.weight
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "weight", $event)
      }
    },
    model: {
      value: (_vm.freight.weight),
      callback: function($$v) {
        _vm.$set(_vm.freight, "weight", $$v)
      },
      expression: "freight.weight"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": 'Объём (м^3)' + (_vm.OversizeType.find(function (item) { return (item == 'size' || item == 'volume'); }) ? ', <span style=color: red;>Негабарит</span>' : ''),
      "required": true,
      "select-on-focus": true,
      "name": "freight_size",
      "id": "freight_size",
      "error": _vm.errors.first('freight_size'),
      "data-vv-name": "freight_size",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": (_vm.blocked || (!!_vm.computedVolume && _vm.computedVolume > 0)),
      "inline": "inline",
      "dirty": _vm.dirtyObj.size
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "size", $event)
      }
    },
    model: {
      value: (_vm.freight.size),
      callback: function($$v) {
        _vm.$set(_vm.freight, "size", $$v)
      },
      expression: "freight.size"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Количество мест",
      "required": true,
      "select-on-focus": true,
      "name": "freight_seats_number",
      "id": "freight_seats_number",
      "error": _vm.errors.first('freight_seats_number'),
      "data-vv-name": "freight_seats_number",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.seats
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "seats", $event)
      }
    },
    model: {
      value: (_vm.freight.seats_number),
      callback: function($$v) {
        _vm.$set(_vm.freight, "seats_number", $$v)
      },
      expression: "freight.seats_number"
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50 deal-freight-card__freight-params"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (!_vm.freight.size || _vm.freight.size < 0),
        min_value: (_vm.freight.size ? 0 : 0.001),
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": 'Высота (м)' + (_vm.OversizeType.find(function (item) { return item == 'height'; }) ? ', <span style=color: red;>Негабарит</span>' : ''),
      "select-on-focus": true,
      "name": "freight_height",
      "id": "freight_height",
      "error": _vm.errors.first('freight_height'),
      "data-vv-name": "freight_height",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.height
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "height", $event)
      }
    },
    model: {
      value: (_vm.freight.height),
      callback: function($$v) {
        _vm.$set(_vm.freight, "height", $$v)
      },
      expression: "freight.height"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (!_vm.freight.size || _vm.freight.size < 0),
        min_value: (_vm.freight.size ? 0 : 0.001),
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": 'Длина (м)' + (_vm.OversizeType.find(function (item) { return item == 'length'; }) ? ', <span style=color: red;>Негабарит</span>' : ''),
      "select-on-focus": true,
      "name": "freight_length",
      "id": "freight_length",
      "error": _vm.errors.first('freight_length'),
      "data-vv-name": "freight_length",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.length
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "length", $event)
      }
    },
    model: {
      value: (_vm.freight.length),
      callback: function($$v) {
        _vm.$set(_vm.freight, "length", $$v)
      },
      expression: "freight.length"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (!_vm.freight.size || _vm.freight.size < 0),
        min_value: (_vm.freight.size ? 0 : 0.001),
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": 'Ширина (м)' + (_vm.OversizeType.find(function (item) { return item == 'width'; }) ? ', <span style=color: red;>Негабарит</span>' : ''),
      "select-on-focus": true,
      "name": "freight_width",
      "id": "freight_width",
      "error": _vm.errors.first('freight_width'),
      "data-vv-name": "freight_width",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.width
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "width", $event)
      }
    },
    model: {
      value: (_vm.freight.width),
      callback: function($$v) {
        _vm.$set(_vm.freight, "width", $$v)
      },
      expression: "freight.width"
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [_c('z-check', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.weight > 0 && _vm.freight.size > 0),
      expression: "freight.weight > 0 && freight.size > 0"
    }],
    attrs: {
      "label": ("Негабаритный груз " + (_vm.fullOversizeMessage ? '(' + _vm.fullOversizeMessage +  ')' : '')),
      "id": "freight_oversize",
      "value": 1,
      "error": _vm.errors.first('freight_oversize'),
      "data-vv-name": "freight_oversize",
      "data-vv-as": ' ',
      "disabled": _vm.blocked || (!!parseInt(_vm.freight.full_oversize) && !!parseInt(_vm.freight.doom)),
      "dirty": _vm.dirtyObj.oversize
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "oversize", $event)
      }
    },
    model: {
      value: (_vm.freight.oversize),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize", $$v)
      },
      expression: "freight.oversize"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.freight.oversize) === 1),
      expression: "parseInt(freight.oversize) === 1"
    }],
    staticClass: "md-layout-item md-alignment-top-left md-size-50 deal-freight-card__freight-params"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (parseInt(_vm.freight.oversize) === 1),
        min_value: 0,
        max_value: ((!!parseInt(_vm.freight.full_oversize)) ? 25000 : (_vm.freight.weight ? parseFloat(_vm.freight.weight) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: (parseInt(freight.oversize) === 1), min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 25000 : (freight.weight ? parseFloat(freight.weight) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Вес негабарита",
      "required": true,
      "select-on-focus": true,
      "name": "freight_oversize_weight",
      "id": "freight_oversize_weight",
      "type": "number",
      "error": _vm.errors.first('freight_oversize_weight'),
      "data-vv-name": "freight_oversize_weight",
      "data-vv-as": ' ',
      "disabled": _vm.blocked || (!!parseInt(_vm.freight.full_oversize) && !!parseInt(_vm.freight.doom)),
      "inline": "inline",
      "dirty": _vm.dirtyObj.oversizeWeight
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "oversizeWeight", $event)
      }
    },
    model: {
      value: (_vm.freight.oversize_weight),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_weight", $$v)
      },
      expression: "freight.oversize_weight"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (parseInt(_vm.freight.oversize) === 1),
        min_value: 0,
        max_value: ((!!parseInt(_vm.freight.full_oversize)) ? 9999999999 : (_vm.freight.size ? parseFloat(_vm.freight.size) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: (parseInt(freight.oversize) === 1), min_value: 0, max_value:  ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.size ? parseFloat(freight.size) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Объём негабарита",
      "required": true,
      "select-on-focus": true,
      "name": "freight_oversize_size",
      "id": "freight_oversize_size",
      "type": "number",
      "error": _vm.errors.first('freight_oversize_size'),
      "data-vv-name": "freight_oversize_size",
      "data-vv-as": ' ',
      "disabled": (_vm.blocked || (!!parseInt(_vm.freight.full_oversize) && !!parseInt(_vm.freight.doom))),
      "inline": "inline",
      "dirty": _vm.dirtyObj.oversizeSize
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "oversizeSize", $event)
      }
    },
    model: {
      value: (_vm.freight.oversize_size),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_size", $$v)
      },
      expression: "freight.oversize_size"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.freight.oversize) === 1 && !_vm.hasDoom && _vm.computedSum > 0),
      expression: "parseInt(freight.oversize) === 1 && !hasDoom && computedSum > 0"
    }],
    staticClass: "md-layout-item md-alignment-top-left md-size-50 deal-freight-card__freight-params"
  }, [_c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.freight.height > 0 ? true : false)),
      expression: "(!hasDoom && parseInt(freight.oversize) && freight.height > 0 ? true : false)"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: ((!!parseInt(_vm.freight.full_oversize)) ? 9999999999 : (_vm.freight.height ? parseFloat(_vm.freight.height) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: false, min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.height ? parseFloat(freight.height) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Высота негабарита (м)",
      "select-on-focus": true,
      "name": "freight_oversize_height",
      "id": "freight_oversize_height",
      "error": _vm.errors.first('freight_oversize_height'),
      "data-vv-name": "freight_oversize_height",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": true,
      "inline": "inline",
      "dirty": _vm.dirtyObj.oversizeHeight
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "oversizeHeight", $event)
      }
    },
    model: {
      value: (_vm.freight.oversize_height),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_height", $$v)
      },
      expression: "freight.oversize_height"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.freight.length > 0 ? true : false)),
      expression: "(!hasDoom && parseInt(freight.oversize) && freight.length > 0 ? true : false)"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: ((!!parseInt(_vm.freight.full_oversize)) ? 9999999999 : (_vm.freight.length ? parseFloat(_vm.freight.length) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: false, min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.length ? parseFloat(freight.length) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Длина негабарита (м)",
      "select-on-focus": true,
      "name": "freight_oversize_length",
      "id": "freight_oversize_length",
      "error": _vm.errors.first('freight_oversize_length'),
      "data-vv-name": "freight_oversize_length",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": true,
      "inline": "inline",
      "dirty": _vm.dirtyObj.oversizeLength
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "oversizeLength", $event)
      }
    },
    model: {
      value: (_vm.freight.oversize_length),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_length", $$v)
      },
      expression: "freight.oversize_length"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.freight.width > 0 ? true : false)),
      expression: "(!hasDoom && parseInt(freight.oversize) && freight.width > 0 ? true : false)"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: ((!!parseInt(_vm.freight.full_oversize)) ? 9999999999 : (_vm.freight.width ? parseFloat(_vm.freight.width) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: false, min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.width ? parseFloat(freight.width) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Ширина негабарита (м)",
      "select-on-focus": true,
      "name": "freight_oversize_width",
      "id": "freight_oversize_width",
      "error": _vm.errors.first('freight_oversize_width'),
      "data-vv-name": "freight_oversize_width",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": true,
      "inline": "inline",
      "dirty": _vm.dirtyObj.oversizeWidth
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "oversizeWidth", $event)
      }
    },
    model: {
      value: (_vm.freight.oversize_width),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_width", $$v)
      },
      expression: "freight.oversize_width"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.computedSum > 0 ? true : false)),
      expression: "(!hasDoom && parseInt(freight.oversize) && computedSum > 0 ? true : false)"
    }],
    attrs: {
      "label": 'Сумма (м)' + (_vm.OversizeType.find(function (item) { return item == 'sum'; }) ? ', <span style=color: red;>Негабарит</span>' : ''),
      "value": _vm.computedSum,
      "required": true,
      "select-on-focus": true,
      "name": "freight_oversize_sum",
      "id": "freight_oversize_sum",
      "type": "number",
      "data-vv-name": "freight_oversize_sum",
      "data-vv-as": ' ',
      "disabled": true,
      "inline": "inline",
      "dirty": _vm.dirtyObj.sum
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "sum", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Услуги")]), _c('z-check', {
    attrs: {
      "label": "Оформление ТТН",
      "id": "freight_ttn",
      "value": true,
      "error": _vm.errors.first('freight_ttn'),
      "data-vv-name": "freight_ttn",
      "data-vv-as": ' ',
      "disabled": true
    },
    model: {
      value: (_vm.ttn),
      callback: function($$v) {
        _vm.ttn = $$v
      },
      expression: "ttn"
    }
  }), _c('z-check', {
    attrs: {
      "label": "Представление интересов в аэропорту",
      "id": "freight_airport_service",
      "value": 1,
      "error": _vm.errors.first('freight_airport_service'),
      "data-vv-name": "freight_airport_service",
      "data-vv-as": ' ',
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.airportService
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "airportService", $event)
      }
    },
    model: {
      value: (_vm.freight.airport_service),
      callback: function($$v) {
        _vm.$set(_vm.freight, "airport_service", $$v)
      },
      expression: "freight.airport_service"
    }
  }), _c('z-check', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.weight > 0 && _vm.freight.size > 0),
      expression: "freight.weight > 0 && freight.size > 0"
    }],
    attrs: {
      "label": _vm.doomLabel,
      "id": "freight_doom",
      "value": 1,
      "error": _vm.errors.first('freight_doom'),
      "data-vv-name": "freight_doom",
      "data-vv-as": ' ',
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.doom
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "doom", $event)
      }
    },
    model: {
      value: (_vm.freight.doom),
      callback: function($$v) {
        _vm.$set(_vm.freight, "doom", $$v)
      },
      expression: "freight.doom"
    }
  }), (_vm.freight.extraservices && _vm.freight.extraservices.doom_make) ? _c('div', [_c('ZFreightExtraService', {
    ref: ('extraserivce-doom_make'),
    attrs: {
      "disabledCheck": true,
      "payers": _vm.$props.payers,
      "name": ('extraserivce-doom_make'),
      "label": _vm.freight.extraservices.doom_make.name,
      "disabled": _vm.blocked || !_vm.freight.doom
    },
    model: {
      value: (_vm.freight.extraservices.doom_make.value),
      callback: function($$v) {
        _vm.$set(_vm.freight.extraservices.doom_make, "value", $$v)
      },
      expression: "freight.extraservices.doom_make.value"
    }
  })], 1) : _vm._e(), _vm._l((_vm.extraservicesDefault), function(service, key) {
    return (_vm.freight.extraservices && Object.values(_vm.freight.extraservices).length) ? _c('div', [(!['doom_make', 'storage'].indexOf(key) + 1) ? _c('ZFreightExtraService', {
      ref: ('extraserivce-' + key),
      refInFor: true,
      attrs: {
        "payers": _vm.$props.payers,
        "name": ('extraserivce-' + key),
        "label": service.label,
        "disabled": _vm.blocked
      },
      model: {
        value: (_vm.freight.extraservices[key]['value']),
        callback: function($$v) {
          _vm.$set(_vm.freight.extraservices[key], 'value', $$v)
        },
        expression: "freight.extraservices[key]['value']"
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [(_vm.freight.extraservices && _vm.freight.extraservices.storage) ? _c('div', [_c('ZFreightExtraService', {
    ref: ('extraserivce-storage'),
    attrs: {
      "payers": _vm.$props.payers,
      "name": ('extraserivce-storage'),
      "label": _vm.freight.extraservices.storage.name,
      "disabledCheck": true,
      "disabled": _vm.blocked
    },
    model: {
      value: (_vm.freight.extraservices.storage.value),
      callback: function($$v) {
        _vm.$set(_vm.freight.extraservices.storage, "value", $$v)
      },
      expression: "freight.extraservices.storage.value"
    }
  })], 1) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwFrom || _vm.shwowLuwTo),
      expression: "shwowLuwFrom || shwowLuwTo"
    }],
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Погрузочно-разгрузочные работы")]), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwFrom),
      expression: "shwowLuwFrom"
    }],
    staticClass: "md-caption",
    domProps: {
      "innerHTML": _vm._s(("Отправление " + (_vm.fromLuw.min_time ? ' <b>(мин. ' + _vm.fromLuw.min_time + 'ч)</b>' : '')))
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwFrom),
      expression: "shwowLuwFrom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: 99999
      }),
      expression: "{ required: false, min_value: 0, max_value: 99999 }"
    }],
    attrs: {
      "label": "Сотрудники",
      "name": "freight_from_luw_workers",
      "id": "freight_from_luw_workers",
      "error": _vm.errors.first('freight_from_luw_workers'),
      "data-vv-name": "freight_from_luw_workers",
      "data-vv-as": ' ',
      "type": "number",
      "inline": "inline",
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.fromLuwWorkers
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "fromLuwWorkers", $event)
      }
    },
    model: {
      value: (_vm.freight.from_luw_workers),
      callback: function($$v) {
        _vm.$set(_vm.freight, "from_luw_workers", $$v)
      },
      expression: "freight.from_luw_workers"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwFrom),
      expression: "shwowLuwFrom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: 99999
      }),
      expression: "{ required: false, min_value: 0, max_value: 99999 }"
    }],
    attrs: {
      "label": "Часы",
      "name": "freight_from_luw_hours",
      "id": "freight_from_luw_hours",
      "error": _vm.errors.first('freight_from_luw_hours'),
      "data-vv-name": "freight_from_luw_hours",
      "data-vv-as": ' ',
      "type": "number",
      "inline": "inline",
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.fromLuwHours
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "fromLuwHours", $event)
      }
    },
    model: {
      value: (_vm.freight.from_luw_hours),
      callback: function($$v) {
        _vm.$set(_vm.freight, "from_luw_hours", $$v)
      },
      expression: "freight.from_luw_hours"
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwTo),
      expression: "shwowLuwTo"
    }],
    staticClass: "md-caption",
    domProps: {
      "innerHTML": _vm._s(("Назначение " + (_vm.toLuw.min_time ? ' <b>(мин. ' + _vm.toLuw.min_time + 'ч)</b>' : '')))
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwTo),
      expression: "shwowLuwTo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: 99999
      }),
      expression: "{ required: false, min_value: 0, max_value: 99999 }"
    }],
    attrs: {
      "label": "Сотрудники",
      "name": "freight_to_luw_workers",
      "id": "freight_to_luw_workers",
      "error": _vm.errors.first('freight_to_luw_workers'),
      "data-vv-name": "freight_to_luw_workers",
      "data-vv-as": ' ',
      "type": "number",
      "inline": "inline",
      "disabled": _vm.blocked && _vm.freight.to_luw_workers > 0 && !_vm.dirtyObj.toLuwWorkers,
      "dirty": _vm.dirtyObj.toLuwWorkers
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "toLuwWorkers", $event)
      }
    },
    model: {
      value: (_vm.freight.to_luw_workers),
      callback: function($$v) {
        _vm.$set(_vm.freight, "to_luw_workers", $$v)
      },
      expression: "freight.to_luw_workers"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowLuwTo),
      expression: "shwowLuwTo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: 99999
      }),
      expression: "{ required: false, min_value: 0, max_value: 99999 }"
    }],
    attrs: {
      "label": "Часы",
      "name": "freight_to_luw_hours",
      "id": "freight_to_luw_hours",
      "error": _vm.errors.first('freight_to_luw_hours'),
      "data-vv-name": "freight_to_luw_hours",
      "data-vv-as": ' ',
      "type": "number",
      "inline": "inline",
      "disabled": _vm.blocked && _vm.freight.to_luw_hours > 0 && !_vm.dirtyObj.toLuwHours,
      "dirty": _vm.dirtyObj.toLuwHours
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "toLuwHours", $event)
      }
    },
    model: {
      value: (_vm.freight.to_luw_hours),
      callback: function($$v) {
        _vm.$set(_vm.freight, "to_luw_hours", $$v)
      },
      expression: "freight.to_luw_hours"
    }
  })], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowManipulatorFrom || _vm.shwowManipulatorTo),
      expression: "shwowManipulatorFrom || shwowManipulatorTo"
    }],
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Услуги манипулятора")]), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [_c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowManipulatorFrom),
      expression: "shwowManipulatorFrom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: 99999
      }),
      expression: "{ required: false, min_value: 0, max_value: 99999 }"
    }],
    attrs: {
      "label": ("Отправление " + (_vm.manupulatorPrice.min_time ? ' <br/><b>(мин. ' + _vm.manupulatorPrice.min_time + 'ч, ' + _vm.manupulatorPrice.price + 'руб./ч)</b>' : '(часы)')),
      "name": "freight_from_manipulator_hours",
      "id": "freight_from_manipulator_hours",
      "error": _vm.errors.first('freight_from_manipulator_hours'),
      "data-vv-name": "freight_from_manipulator_hours",
      "data-vv-as": ' ',
      "type": "number",
      "inline": "inline",
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.fromManipulatorHours
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "fromManipulatorHours", $event)
      }
    },
    model: {
      value: (_vm.freight.from_manipulator_hours),
      callback: function($$v) {
        _vm.$set(_vm.freight, "from_manipulator_hours", $$v)
      },
      expression: "freight.from_manipulator_hours"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shwowManipulatorTo),
      expression: "shwowManipulatorTo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: 99999
      }),
      expression: "{ required: false, min_value: 0, max_value: 99999 }"
    }],
    attrs: {
      "label": ("Назначение " + (_vm.manupulatorPrice.min_time ? ' <b>(мин. ' + _vm.manupulatorPrice.min_time + 'ч)</b>' : '(часы)')),
      "name": "freight_to_manipulator_hours",
      "id": "freight_to_manipulator_hours",
      "error": _vm.errors.first('freight_to_manipulator_hours'),
      "data-vv-name": "freight_to_manipulator_hours",
      "data-vv-as": ' ',
      "type": "number",
      "inline": "inline",
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.toManipulatorHours
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "toManipulatorHours", $event)
      }
    },
    model: {
      value: (_vm.freight.to_manipulator_hours),
      callback: function($$v) {
        _vm.$set(_vm.freight, "to_manipulator_hours", $$v)
      },
      expression: "freight.to_manipulator_hours"
    }
  })], 1)])])]), _c('div', {
    staticClass: "md-layout md-gutter"
  }, _vm._l((_vm.servicesSections), function(serviceSection, i) {
    return _c('div', {
      key: ('freight-services-section-' + i),
      staticClass: "md-layout-item md-size-50"
    }, [_c('div', {
      staticClass: "md-subheading"
    }, [_vm._v(_vm._s(serviceSection.title))]), (_vm.services && _vm.services[serviceSection.key]) ? _c('div', {
      staticClass: "md-layout md-gutter"
    }, _vm._l((_vm.services[serviceSection.key]), function(item, s) {
      return _c('div', {
        key: ('service-' + item.id),
        staticClass: "md-layout-item md-alignment-top-left md-size-100"
      }, [((['checkbox', 'grid-city', 'grid-dimensions', 'grid-paymethod', 'grid-city-dimensions'].indexOf(item.type) + 1) && item.values && item.values.length === 1) ? _c('div', _vm._l((item.values), function(check, n) {
        return _c('z-check', {
          key: ('service-item-check-' + check.id),
          attrs: {
            "label": check.name,
            "name": ('freight_service_' + item.id),
            "id": ('freight_service_' + item.id + '-' + check.id),
            "value": check.id,
            "error": _vm.errors.first(('freight_service_' + item.id + '-' + check.id)),
            "data-vv-name": ('freight_service_' + item.id + '-' + check.id),
            "data-vv-as": ' ',
            "disabled": _vm.blocked,
            "dirty": _vm.dirtyObj[('service-' + item.id + '-' + check.id)]
          },
          on: {
            "update:dirty": function($event) {
              _vm.$set(_vm.dirtyObj, ('service-' + item.id + '-' + check.id), $event)
            },
            "change": _vm.changeService
          },
          model: {
            value: (item.value),
            callback: function($$v) {
              _vm.$set(item, "value", $$v)
            },
            expression: "item.value"
          }
        })
      })) : _vm._e(), (item.type == 'checkbox' && item.values && item.values.length > 1) ? _c('div', {
        staticClass: "z-check-container"
      }, [_c('div', {
        staticClass: "md-caption"
      }, [_vm._v(_vm._s(item.name))]), _c('div', {
        staticClass: "md-layout md-gutter"
      }, _vm._l((item.values), function(check, n) {
        return _c('div', {
          key: ('service-item-mcheck-' + check.id),
          staticClass: "md-layout-item md-size-100"
        }, [_c('z-check', {
          attrs: {
            "label": check.name,
            "name": ('freight_service_' + item.id),
            "id": ('freight_service_' + item.id + '-' + check.id),
            "value": parseInt(check.id),
            "error": _vm.errors.first(('freight_service_' + item.id + '-' + check.id)),
            "data-vv-name": ('freight_service_' + item.id + '-' + check.id),
            "data-vv-as": ' ',
            "disabled": _vm.blocked,
            "dirty": _vm.dirtyObj[('service-' + item.id + '-' + check.id)]
          },
          on: {
            "update:dirty": function($event) {
              _vm.$set(_vm.dirtyObj, ('service-' + item.id + '-' + check.id), $event)
            },
            "change": _vm.changeService
          },
          model: {
            value: (item.value),
            callback: function($$v) {
              _vm.$set(item, "value", $$v)
            },
            expression: "item.value"
          }
        })], 1)
      }))]) : _vm._e(), (item.type == 'select') ? _c('div', [_c('z-select', {
        attrs: {
          "label": item.name,
          "name": ('freight_service_' + item.id),
          "id": ('freight_service_' + item.id),
          "error": _vm.errors.first(('freight_service_' + item.id)),
          "data-vv-name": ('freight_service_' + item.id),
          "data-vv-as": ' ',
          "disabled": _vm.blocked,
          "inline": "inline",
          "dirty": _vm.dirtyObj[('service-' + item.id)]
        },
        on: {
          "update:dirty": function($event) {
            _vm.$set(_vm.dirtyObj, ('service-' + item.id), $event)
          }
        },
        model: {
          value: (item.value),
          callback: function($$v) {
            _vm.$set(item, "value", $$v)
          },
          expression: "item.value"
        }
      }, [_c('option', {
        key: ("freight_service_" + (item.id) + "-default"),
        attrs: {
          "value": ""
        }
      }, [_vm._v("Укажите значение")]), _vm._l((item.values), function(check) {
        return _c('option', {
          key: check.id,
          domProps: {
            "value": check.id
          }
        }, [_vm._v(_vm._s(check.id + ' - ' + check.name))])
      })], 2)], 1) : _vm._e()])
    })) : _vm._e()])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Основные характеристики")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7cf07c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/Freight.vue
// module id = 1052
// module chunks = 0